import { createFileRoute, redirect } from '@tanstack/react-router';
import OrganisationsPage from '@/app/organisations/page';
import { getSessionJwt } from '@/services/auth';

// Fields are optional so other routes can navigate to "/organisations" without
// supplying search params; validateSearch always fills concrete defaults below.
export interface OrganisationsSearch {
  page?: number;
  pageSize?: number;
  search?: string;
}

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

export const Route = createFileRoute('/organisations/')({
  component: OrganisationsPage,
  // Persist pagination + search in the URL so navigating into an organisation
  // and back (or using the browser back button) restores the page the user was on.
  validateSearch: (search: Record<string, unknown>): OrganisationsSearch => {
    const page = Number(search.page);
    const pageSize = Number(search.pageSize);

    return {
      page: Number.isFinite(page) && page >= 1 ? Math.floor(page) : DEFAULT_PAGE,
      pageSize:
        Number.isFinite(pageSize) && pageSize >= 1
          ? Math.floor(pageSize)
          : DEFAULT_PAGE_SIZE,
      search: typeof search.search === 'string' ? search.search : '',
    };
  },
  beforeLoad: () => {
    // Redirect to login if not authenticated
    if (!getSessionJwt()) {
      throw redirect({ to: '/login' });
    }
  },
});
